import * as damConnectionStatusTypes from '../../consts/dam/damConnectionStatusTypes';
import uamfApiErrorMessages from '../../consts/uamf/uamfApiErrorMessages';
import {setDeviceConnectionStatus, setHolderLastChargerDusn, updateDeviceData} from '../../state/slice/iotDevices';
import {dispatch} from '../../state/store';
import log from '../logger/log';
import storageService from '../storageService';
import uamfClientService from './uamfClientService';

const applyDeviceConnectionStatus = (dusn, data) => {
    const {status, connectionType, lastChargerDusn, dependantDevice, dependantDeviceCodentify} = data || {};

    if (status) {
        dispatch(setDeviceConnectionStatus(dusn, status));
    }

    if (connectionType) {
        dispatch(updateDeviceData(dusn, {connectionType}));
    }

    if (lastChargerDusn) {
        dispatch(setHolderLastChargerDusn(dusn, lastChargerDusn));
        storageService.setDeviceKitMapEntry(lastChargerDusn, dusn);
    }

    if (dependantDevice) {
        dispatch(setHolderLastChargerDusn(dependantDevice, dusn));
        storageService.setDeviceKitMapEntry(dusn, dependantDevice);

        if (dependantDeviceCodentify) {
            dispatch(updateDeviceData(dependantDevice, {codentify: dependantDeviceCodentify}));
        }
    }

    return status;
};

const getDeviceConnectionStatus = async (dusn, isThrowError) => {
    let data;

    try {
        data = await uamfClientService.getDeviceConnectionStatus(dusn, isThrowError);
    } catch (e) {
        // After registration, backend can return a DEVICE_NOT_FOUND error for a period of time
        // This is expected, so handle it as a disconnected status
        if (e?.response?.data?.error === uamfApiErrorMessages.DEVICE_NOT_FOUND) {
            log.warn(
                `uamfDeviceService: Device connectivity status failed, dusn: ${dusn}, error:${uamfApiErrorMessages.DEVICE_NOT_FOUND}, handle it as a disconnected status`
            );

            dispatch(setDeviceConnectionStatus(dusn, damConnectionStatusTypes.DISCONNECTED));

            return damConnectionStatusTypes.DISCONNECTED;
        }

        throw e;
    }

    return applyDeviceConnectionStatus(dusn, data);
};

export default {
    getDeviceConnectionStatus,
    applyDeviceConnectionStatus,
};
